module.exports = __webpack_public_path__ + "static/iPhone-8701ade584c2640506e925e1fdc28cc8.png";